import { PlanogramContainerCommonNonCircular } from "@CommonTypes/merchflow/pog/container";
import { Tag } from "src/elements";

interface Props {
  container: PlanogramContainerCommonNonCircular;
}

export const ContainerDetails = ({ container }: Props) => {
  const cdt0 = container.cdts[0].cdt0;
  const cdt1 = "cdt1" in container.cdts[0] ? container.cdts[0].cdt1 : null;
  const cdt2 = "cdt2" in container.cdts[0] ? container.cdts[0].cdt2 : null;

  return (
    <>
      {cdt0 && <Tag label="CDT0" value={cdt0} />}

      {cdt1 && <Tag label="CDT1" value={cdt1} />}

      {cdt2 && <Tag label="CDT2" value={cdt2} />}
    </>
  );
};
